global.conmed = global.conmed || {};

conmed.tabSliders = function ($) {
    'use strict';
    var that = {
        selectors: {
            slider: '.js-tab-slider',
            sliderItemLink: ".tab-slider-item-link",
            sliderHeroTitle: ".tab-slider-section .hero-header",
            sliderHeroDescription: ".tab-slider-section .desc",
            sliderCTA: ".sliderCTA",
            sliderBtnLabel: ".btn-label",
            sliderSection: ".tab-slider-section"
        }
    };

    that.init = function () {

        $('.tab-slider').slick({
            
            slidesToShow: 4,
            slidesToScroll: 4,
            responsive: [
                {
                  breakpoint: 1189,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                  }
                },
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                  }
                },
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                }
              ]
           
        });

        function isBreakPoint(bp) {

            var bps = [480, 768, 1189],
                w = $(window).width();

            if (bp >= bps[bps.length - 1]) {
                return true;
            }
            else if (bp > bps[0] && bp <= bps[1]) {
                return true;
            }
            else if (bp > bps[1] && bp < bps[2]) {
                return true;
            }
            else {
                return false;
            }
            
        }

        $(that.selectors.sliderItemLink).on("click", function (e) {

            e.preventDefault();

            var title = $(this).data("itm-title");
            var description = $(this).data("itm-description");
            var url = $(this).data("itm-url");
            var linkTitle = $(this).data("itm-btn");
            var smallImage = $(this).data("itm-img-sm");
            var mediumImage = $(this).data("itm-img-md");
            var largeImage = $(this).data("itm-img-lg");

            var contentElement = $(this).closest('.tab-slider-col').children('.content');

            contentElement.children(that.selectors.sliderHeroTitle).text(title);
            contentElement.children(that.selectors.sliderHeroDescription).html(description);
            contentElement.children(that.selectors.sliderCTA).attr("href", url);
            contentElement.find(that.selectors.sliderBtnLabel).text(linkTitle);

            //console.log($(window).width());

            if (isBreakPoint(1189)) {
                //console.log('1189' + largeImage);
                $(this).parents(that.selectors.sliderSection).css("background-image", "url('" + largeImage + "')");
            }
            if (isBreakPoint(768)) {
                //console.log('768' + mediumImage);
                $(this).parents(that.selectors.sliderSection).css("background-image", "url('" + mediumImage + "')");
            }
            if (isBreakPoint(480)) {
                //console.log('480' + smallImage);
                $(this).parents(that.selectors.sliderSection).css("background-image", "url('" + smallImage + "')");
            }

            

        });
    };

    return that;
}(jQuery);